import React from "react"
import "./frames.css"

const SistemaElite = () => {
  return (
    <div className="frames-container">
      <h1 className="frames-title">
        Sistema ELITE: Control Electrónico y Automatizado
      </h1>

      <h2 className="frames-subtitle">
        Gestión Avanzada de Pacientes y Tratamientos
      </h2>
      <p className="frames-text">
        El sistema ELITE eleva las cámaras hiperbáricas de Perry Baromedical a
        un nuevo nivel de eficiencia y control. Gracias a su panel con pantalla
        táctil, los profesionales médicos pueden gestionar y revisar toda la
        información relacionada con los pacientes y sus tratamientos.
      </p>

      <h2 className="frames-subtitle">Flexibilidad en la Terapia</h2>
      <p className="frames-text">
        Ya sea de forma manual o automática, el sistema ELITE ofrece la
        posibilidad de elegir entre perfiles predefinidos o personalizados para
        cada sesión. Estos perfiles incluyen aspectos como la presión y las
        pausas de aire, lo que permite adaptar cada tratamiento a las
        necesidades específicas de cada paciente, reduciendo riesgos como el
        daño en el oído.
      </p>

      <h2 className="frames-subtitle">
        Interconexión y Supervisión Centralizada
      </h2>
      <p className="frames-text">
        Con la capacidad de interconectar múltiples cámaras a través de una
        única base de datos, el sistema ELITE simplifica la labor de
        supervisión. Desde una sola ubicación, es posible controlar todas las
        cámaras de una sala, reduciendo así el número de operadores necesarios.
      </p>

      <h2 className="frames-subtitle">
        Funciones Avanzadas y Diagnóstico Automático
      </h2>
      <p className="frames-text">
        Además de su potente software de gestión, el sistema ofrece diagnósticos
        automáticos con alarmas, operación autónoma, control neumático de
        respaldo y funciones de vaciado de emergencia. Esto asegura un
        tratamiento seguro y eficiente.
      </p>

      <h2 className="frames-subtitle">Actualizaciones y Expansión</h2>
      <p className="frames-text">
        Las cámaras neumáticas de Perry ya en servicio pueden actualizarse al
        sistema ELITE, lo que facilita la expansión de unidades y la
        incorporación de nuevos centros con un sistema de gestión unificado.
      </p>
    </div>
  )
}

export default SistemaElite
